export interface IUbsUserState {
  points: number;
}

export const initialUbsUserState: IUbsUserState = {
  points: 0
};
